import requestv2 from "~/utils/http-v2";

const projectApi = {
	gets : async (params) => {
		const url = 'v2/project';
		return await requestv2.get(url, {params});
	},
	search : async (params) => {
		const url = 'v2/project/search';
		return await requestv2.get(url, {params});
	},
	history : async (id) => {
		const url = `v2/project/history/${id}`;
		return await requestv2.get(url);
	},
	add : async (params) => {
		const url = 'v2/project';
		return await requestv2.post(url, params);
	},
	update : async (params) => {
		const url = `v2/project/${params.id}`;
		return await requestv2.patch(url, params);
	},
	delete : async (id) => {
		const url = `v2/project/${id}`;
		return await requestv2.delete(url);
	},
	deadline : async (params) => {
		const url = `v2/project/deadline/${params.id}`;
		return await requestv2.post(url, params);
	},
	status : async (params) => {
		const url = `v2/project/status/${params.id}`;
		return await requestv2.post(url, params);
	},
	phase : async (params) => {
		const url = `v2/project/phase/${params.id}`;
		return await requestv2.post(url, params);
	},
	install : async (params) => {
		const url = `v2/project/install/${params.id}`;
		return await requestv2.post(url, params);
	},
	assign : async (params) => {
		const url = `v2/project/assign/${params.id}`;
		return await requestv2.post(url, params);
	},
	fileUpload : async (id, params) => {
		const url = `v2/project/file/${id}`;
		return await requestv2.post(url, params, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		});
	},
	fileRemove : async (id, params) => {
		const url = `v2/project/file/delete/${id}`;
		return await requestv2.post(url, params);
	},
	getsWithTask : async (params) => {
		const url = `v2/project/tasks`;
		return await requestv2.get(url, {params});
	},
};

export default projectApi;